import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getFirestore,
  setDoc,
} from "firebase/firestore";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import {
  EmailAuthProvider,
  createUserWithEmailAndPassword,
  getAuth,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth();

const firestore = getFirestore(app);
export const storage = getStorage(app);

const analytics = getAnalytics(app);

/////////////////////////////////////
// FIRESTORE
/////////////////////////////////////
export const FIRESTORE_RESULTS = {
  ALREADY_EXIST: "ALREADY_EXIST",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

export async function addPreRegistration(contact: string) {
  try {
    const preRegistrationRef = collection(firestore, "pre_registration");
    const docRef = doc(firestore, "pre_registration", contact);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return FIRESTORE_RESULTS.ALREADY_EXIST;
    } else {
      await setDoc(doc(preRegistrationRef, contact), {
        contact,
      });

      return FIRESTORE_RESULTS.SUCCESS;
    }
  } catch (err) {
    console.log(err);
    return FIRESTORE_RESULTS.FAILED;
  }
}

/////////////////////////////////////
// AUTH
/////////////////////////////////////

export async function firebaseSignUp(email: string, password: string) {
  return await createUserWithEmailAndPassword(firebaseAuth, email, password);
}

export async function firebaseSignIn(email: string, password: string) {
  await signInWithEmailAndPassword(firebaseAuth, email, password);
}

export async function firebaseSignOut() {
  await signOut(firebaseAuth);
}

export async function sendFirebasePasswordResetEmail(email: string) {
  await sendPasswordResetEmail(firebaseAuth, email);
}

export async function updateFirebasePassword(password: string) {
  if (firebaseAuth.currentUser) {
    await updatePassword(firebaseAuth.currentUser, password);
  }
}

export async function firebaseReAuthenticate(currentPassword: string) {
  const { currentUser } = firebaseAuth;
  if (currentUser) {
    const credential = EmailAuthProvider.credential(
      currentUser?.email!,
      currentPassword
    );
    await reauthenticateWithCredential(currentUser, credential);
  }
}

/**
 * It first checks if token is expired.
 * If expired, it return refreshed access token.
 * Otherwise, returns token from cache.
 */
export async function getFirebaseIdToken() {
  return await firebaseAuth.currentUser?.getIdToken();
}

export const FIREBASE_AUTH_ERROR_CODES = {
  "auth/user-not-found": "auth/user-not-found",
  "auth/invalid-password": "auth/invalid-password",
  "auth/email-already-exists": "auth/email-already-exists",
};

export async function uploadToFirebaseStorage(
  file: any,
  metadata: any,
  category: string
): Promise<string> {
  const storageRef = ref(storage, category + "/" + new Date() + file.name);
  const uploadTask = uploadBytesResumable(storageRef, file, metadata);

  return new Promise((resolve) => {
    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      },
      (error) => {
        console.log(error);
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          resolve(downloadURL);
        });
      }
    );
  });
}
